var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9271_2424",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9271_2424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9556 15.6469L3.19922 7.89049L4.16522 6.91039L10.9556 13.7008L16.4503 8.20603H11.9163V6.83105H18.7913V13.706H17.4163V9.18613L10.9556 15.6469Z",
    fill: "#9A17C8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissed);
export default __webpack_public_path__ + "static/media/missed.bed55f78c8688e64148573bd46629254.svg";
export { ForwardRef as ReactComponent };